import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetUserPinStatusQueryVariables = Types.Exact<{
   params: Types.GetUserPinStatusParams
}>

export type GetUserPinStatusQuery = {
   __typename?: 'Query'
   getUserPinStatus:
      | {
           __typename?: 'UserPinExpired'
           message?: string | null
           expiresAt?: string | null
           lastChangedAt?: string | null
        }
      | {
           __typename?: 'UserPinLocked'
           message?: string | null
           lockedUntil: string
           expiresAt?: string | null
           lastChangedAt?: string | null
        }
      | { __typename?: 'UserPinNotConfigured'; message?: string | null }
      | {
           __typename?: 'UserPinStatus'
           expiresAt?: string | null
           lastChangedAt?: string | null
        }
}

export const GetUserPinStatusDocument = gql`
   query GetUserPinStatus($params: GetUserPinStatusParams!) {
      getUserPinStatus(params: $params) {
         ... on UserPinStatus {
            expiresAt
            lastChangedAt
         }
         ... on UserPinNotConfigured {
            message
         }
         ... on UserPinLocked {
            message
            lockedUntil
            expiresAt
            lastChangedAt
         }
         ... on UserPinExpired {
            message
            expiresAt
            lastChangedAt
         }
      }
   }
`
export type GetUserPinStatusQueryResult = Apollo.QueryResult<
   GetUserPinStatusQuery,
   GetUserPinStatusQueryVariables
>
